import taskList from "./en/task-list";
import taskView from "./en/task-view";
import actionButtons from "./en/action-buttons";

export default Object.assign({}, taskList, taskView, actionButtons);
